import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { HomeSoundcoreCmsContent } from 'core/services/cms/interfaces'

import { HomeProductSection } from '../home-product/HomeProductSection'

interface SoundcoreSectionProps {
  content: HomeSoundcoreCmsContent
}

export const SoundcoreSection: React.FC<SoundcoreSectionProps> = ({ content }) => {
  const navigate = useNavigate()

  const handleSoundcoreClick = (): void => {
    if (/^https?:\/\//.test(content.buttonUrl)) {
      window.location.assign(content.buttonUrl)
      return
    }

    navigate(content.buttonUrl)
  }

  return (
    <HomeProductSection
      logoUrl={content.logoUrl}
      text={content.text}
      buttonText={content.buttonText}
      onButtonClick={handleSoundcoreClick}
      desktopBackgroundUrl={content.desktopBackgroundUrl}
      mobileBackgroundUrl={content.mobileBackgroundUrl}
      featureCards={content.featureCards.map((card) => ({
        icon: card.iconUrl,
        text: card.text,
      }))}
    />
  )
}
